import { styled } from "styled-components";

export const PersonalBar = styled.div`
  height: 100%;
`;
